export default __webpack_public_path__ + "static/ambient-dark-c847d07a50702787bea478a7be499cde1ab0529d65c9112bc3a796506def05b1.png";